// AI Generated Component
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccessibilityPdfService } from '@client/app/blocks/service/accessibility/pdf-accessibility.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';

@Component({
    selector: 'document-details-section-accessibility-information',
    standalone: false,
    template: `
        <div class="max-height d-flex flex-column">
            <div class="pl-6 pr-5 py-3 d-flex align-items-center border-bottom">
                <div class="mr-3">
                <span class="fa-stack fa-lg">
                  <span class="fa-stack-2x" aria-hidden="true" [class]="getCheckIconContainer()"></span>
                  <span class="fa-stack-1x" aria-hidden="true" [class]="getCheckIcon()"></span>
                </span>
                </div>
                <div class="mr-auto" [innerHTML]="check.name"></div>
            </div>
            <div class="border-bottom">
                <page-details-sections-tabs class="block mx-4"
                                            [options]="tabs"
                                            (onTabChange)="onTabChange.emit($event.tab)"
                                            [tab]="tab">
                </page-details-sections-tabs>
            </div>
            <div class="flex-grow-1">
                <div class="row d-flex align-items-stretch">
                    <div class="col-48">
                        <mon-spinner [loading]="loading">
                            <div class="mx-2 mt-3 d-flex align-items-center" *ngFor="let error of errors">
                                <div class="mr-2">
                                    <span class="fa-stack fa-lg text-wcag-a">
                                      <span class="fal fa-circle fa-stack-2x"></span>
                                      <span class="fa-stack-1x" [class]="getIcon(error)"></span>
                                    </span>
                                </div>
                                <div class="mr-auto">
                                    <div [innerHTML]="error.reason"></div>
                                    <h5 class="my-1" translate>
                                        Element Tree Path
                                    </h5>
                                    <div class="text-bold" [innerHTML]="error.element_tree_path"></div>
                                </div>
                            </div>
                            <div class="text-center my-6 text-grey" *ngIf="!errors || errors.length === 0">
                                <h3 class="font-weight-400" translate>No errors found</h3>
                            </div>
                        </mon-spinner>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class DocumentDetailsAccessibilityInformationComponent implements OnInit {
    @Input() check: any;
    @Input() errors: any;
    @Input() tab: any;
    @Input() loading: any;
    @Input() document: any;
    @Output() onTabChange = new EventEmitter<any>();

    tabs: any;
    loadingErrors: any;

    constructor (
        private monDialog: MonDialog,
        private translateService: TranslateService,
        private accessibilityPdfAccessibilityService: AccessibilityPdfService,
    ) {}

    ngOnInit (): void {
        this.loadingErrors = false;
        this.setupTabs();
    }

    setupTabs (): void {
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                value: null,
            },
            {
                name: this.translateService.getString('Review'),
                value: 'review',
            },
            {
                name: this.translateService.getString('Warning'),
                value: 'warning',
            },
            {
                name: this.translateService.getString('Error'),
                value: 'error',
            },
        ];
    }

    getCheckIconContainer (): any {
        return this.accessibilityPdfAccessibilityService.getDocumentIconContainer(this.document, this.check);
    }

    getCheckIcon (): any {
        return this.accessibilityPdfAccessibilityService.getDocumentIcon(this.document, this.check);
    }

    getIcon (error: any): string {
        switch (error.result_type) {
            case 'error':
                return 'fas fa-bug';
            case 'review':
                return 'fas fa-eye';
            case 'warning':
                return 'fas fa-bell';
            default:
                return '';
        }
    }
}
